import api from '@/apis/di/projectAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('project', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_project',
    field: {
      key: 'project_id',
      code: 'project_code',
      name: 'project_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
